import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=515b90b0&"
import script from "./VerifyUser.vue?vue&type=script&lang=js&"
export * from "./VerifyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports